import FullCalendarReact from '@fullcalendar/react'
import type { CalendarOptions } from '@fullcalendar/core'
import { styled } from '@mui/material/styles'

const FullCalendarWrapper = styled('div')(({ theme }) => ({
  '.fc-list-event-time': {
    verticalAlign: 'middle',
  },
  '.fc-list-event-graphic': {
    verticalAlign: 'middle',
    textAlign: 'center',
  },
  '.fc-list-event-title': {
    verticalAlign: 'middle',
    maxWidth: '54vw',
  },
  '.fc .fc-list-day-cushion, .fc .fc-list-table td': {
    padding: '8px',
  },
  '.fc-theme-standard .fc-list-day-cushion': {
    backgroundColor: `${theme.colors.accent[500]}`,
    color: `${theme.palette.getContrastText(theme.colors.accent[500])}`,
  },
  '.fc-list-event-no-graphic': {
    '.fc-list-event-dot': {
      display: 'none',
    },
  },
  '.fc-header-toolbar': {
    '.fc-toolbar-chunk:nth-of-type(2) > div': {
      display: 'flex',
      alignItems: 'center',
      gap: '0.5rem',
    },
  },
}))

export default function FullCalendar(props: CalendarOptions) {
  return (
    <FullCalendarWrapper>
      <FullCalendarReact {...props} />
    </FullCalendarWrapper>
  )
}
